import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-admission-open',
    templateUrl: './admission-open.component.html',
    styleUrls: ['./admission-open.component.css'],
    standalone: false
})
export class AdmissionOpenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
